import API, { handleRequest } from '@/api/lib/api'

export const sendVoucherMail = (id, data, config = {}) =>
  handleRequest(() => API.post(`restaurant/vouchers/${id}/send`, data, config))
